import type { TypePermission } from '@/features/domaine/types/opco/Permissions/TypePermission'
import type { IconName } from '@designSystem/fondation/icons/iconsList'
import type { IndicatorConfig } from '../IndicateurTdb.types'

export type IndicateurProps = {
  titre?: DocumentLabel
  count?: number
  loading?: boolean
  slowLoading?: boolean
  error?: boolean
}

export type DocumentCardProps = {
  type: DocumentType
  permissions: TypePermission | TypePermission[]
  indicateurs: Record<VariantType, IndicateurProps>
}

export enum DocumentLabel {
  EnCoursAnalyse = 'en cours d’analyse',
  DossiersCompleter = 'dossiers à compléter',
  NouvellesFactures = 'nouvelles factures',
  FacturesRegulariser = 'factures à régulariser',
  DemandeAValider = 'demande(s) à valider',
  DemandeAccepterRefuser = 'demande(s) acceptée(s) ou refusée(s)',
}

export const DocumentType = ['dossiers', 'factures'] as const
export type DocumentType = (typeof DocumentType)[number]

export const VariantType = ['primary', 'secondary'] as const
export type VariantType = (typeof VariantType)[number]

export type DocumentCardEmit = {
  (event: 'redirection-document', variant: VariantType): void
  (event: 'ajout-document'): void
  (event: 'retry-fetch', variant: VariantType): void
}

export interface DocumentTypeConfig {
  typeLabel: string
  iconName: IconName
  buttonLabel: string
  emptyLabel: string
  errorLabel: string
  primary: IndicatorConfig
  secondary: IndicatorConfig
}

export const documentConfig: Record<DocumentType, DocumentTypeConfig> = {
  dossiers: {
    typeLabel: 'Dossiers',
    iconName: 'folder-open',
    buttonLabel: 'Créer un dossier',
    emptyLabel: 'Retrouvez ici vos dossiers incomplets ou en attente de facturation',
    errorLabel: 'Echec réseau (dossiers)',
    primary: {
      route: '/demandes',
      labelKey: 'DossierIndicateur1',
      getLabel: (tbd) => tbd.DossierIndicateur1.label,
      getPageRequest: (tbd) => tbd.DossierIndicateur1.pageRequest,
    },
    secondary: {
      route: '/dossiers',
      labelKey: 'DossierIndicateur2',
      getLabel: (tbd) => tbd.DossierIndicateur2.label,
      getPageRequest: (tbd) => tbd.DossierIndicateur2.pageRequest,
    },
  },
  factures: {
    typeLabel: 'Factures',
    iconName: 'bill',
    buttonLabel: 'Déposer une facture',
    emptyLabel: 'Retrouvez ici vos nouvelles factures et les factures en relance',
    errorLabel: 'Echec réseau (factures)',
    primary: {
      route: '/factures',
      labelKey: 'FactureIndicateur1',
      getLabel: (tbd) => tbd.FactureIndicateur1.label,
      getPageRequest: (tbd) => tbd.FactureIndicateur1.pageRequest,
    },
    secondary: {
      route: '/factures',
      labelKey: 'FactureIndicateur2',
      getLabel: (tbd) => tbd.FactureIndicateur2.label,
      getPageRequest: (tbd) => tbd.FactureIndicateur2.pageRequest,
    },
  },
} as const
